import { Kbd } from '../../../shared/ui/kbd';
import { Modal } from '../../../shared/ui/modal';
import { NAV_ENTRIES, SHELL_CHORDS, type IChord } from './nav';

const ROWS: readonly (IChord & { label: string })[] = [
  { label: 'Search', ...SHELL_CHORDS.search },
  ...NAV_ENTRIES.map(({ label, keys, hotkey }) => ({ label, keys, hotkey })),
  { label: 'Notifications', ...SHELL_CHORDS.notifications },
  { label: 'Settings', ...SHELL_CHORDS.settings },
  { label: 'Organizations', ...SHELL_CHORDS.organizations },
  { label: 'Account menu', ...SHELL_CHORDS.account },
  { label: 'Collapse or expand the sidebar', ...SHELL_CHORDS.sidebar },
  { label: 'This sheet', ...SHELL_CHORDS.shortcuts },
];

// Only keys that work on every screen; the canvas's own would be promises elsewhere.
export const ShortcutsSheet = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => (
  <Modal
    open={open}
    onOpenChange={onOpenChange}
    title="Keyboard shortcuts"
    description="G, then the letter. They work anywhere outside a text field."
  >
    <dl className="flex flex-col">
      {ROWS.map((row) => (
        <div
          key={row.hotkey}
          className="flex h-control-sm items-center justify-between border-b border-border-row last:border-b-0"
        >
          <dt className="text-data text-primary">{row.label}</dt>
          <dd>
            <Kbd>{row.keys}</Kbd>
          </dd>
        </div>
      ))}
    </dl>
  </Modal>
);
